// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._53Ji7 {
  padding: 2rem;
}
._53Ji7, ._53Ji7 * {
  box-sizing: border-box;
}
._1Lo2h {
  margin: 0 0 1rem 0;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}
._2Jtxm {
  list-style: none;
  position: relative;
  text-align: center;
  flex: 1 1 auto;
  position: relative;
}

._2Jtxm::before {
  content: '';
  position: absolute;
  top: 50%;
  height: 3px;
  width: 100%;
  right: 50%;
  transform: translateY(-50%);
  z-index: -1;
  background: linear-gradient(to left, #e7eaf3 50%, #4db193 50%);
	background-size: 200% 100%;
  background-position: right bottom;
  transition: background-position 200ms ease-in-out;
}
._2Jtxm:first-child::before {
  content: none;
}
._2Jtxm ._2kL0S,
._2Jtxm ._2JvrO {
  background-color: #e7eaf3;
  color: var(--text-normal);
  border-radius: 50%;
  height: 2.5rem;
  width: 2.5rem;
  line-height: 2.5rem;
  display: inline-flex;
  transform-origin: center;
  align-items: center;
  justify-content: center;
}
._2kL0S, ._2JvrO {
  transition: background-color 250ms ease;
}
._2Jtxm ._1hzhf {
  color: var(--text-normal);
  position: absolute;
  top: 120%;
  left: 50%;
  transform: translateX(-50%);
}
._2Jtxm ._1ixJ3 {
  display: block;
}
._2Jtxm._2ZUAI ._2JvrO {
  background-color: #4db193;
  color: white;
  animation: _3SDnc 400ms ease-in-out forwards;
}
._2Jtxm._2ZUAI ._2JvrO:hover {
  background-color: #42997f;
}
._2Jtxm._35Ago ._2kL0S {
  background-color: #387cf6;
  color: white;
  animation: _JAh3L 400ms ease forwards;
}
._2Jtxm._35Ago ._2kL0S:hover {
  background-color: #316ddb;
}
._2Jtxm._2ZUAI::before,
._2Jtxm._35Ago::before,
._2Jtxm._1CcaK::before {
  background-position: left bottom;
}
._2Jtxm._1CcaK ._2JvrO {
  color: white;
  background-color: #bb392d;
  animation: _1ujce 350ms ease-in-out forwards;
}
._2_g61 {
  padding: 1rem;
}
._3uApM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 1rem;
}
._2pGos {
  padding: 0.75rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: all 200ms ease-in-out;
}
._3CDiP {
  border: 1px solid #d1d9eb;
}
._3CDiP:hover {
  background-color: #f3f7ff;
  box-shadow: 0px 3px 6px 0 rgba(190, 201, 228, 0.3);
}
._hsN1w {
  background-color: #397cf6;
  border: 1px solid #397cf6;
  color: white;
}
._hsN1w:hover {
  background-color: #316ddb;
  border: 1px solid #316ddb;
  box-shadow: 0px 3px 6px 0 rgba(57, 124, 246, 0.3);
}
._2pGos._2RWmX {
  pointer-events: none;
  filter: opacity(0.7);
  cursor: default;
}

@keyframes _JAh3L {
  0% { transform: scale(1); }
  10% { transform: scale(0.975); }
  40% { transform: scale(1.4); }
  50%, 100% { transform: scale(1.2); }
}
@keyframes _3SDnc {
  0% { transform: scale(1.2); }
  35%, 100% { transform: scale(1); }
}
@keyframes _1ujce {
  0% { transform: translateX(0); }
  15% { transform: translateX(0.2rem); }
  30%, 60% { transform: translateX(-0.4rem); }
  45%, 75% { transform: translateX(0.4rem); }
  90% { transform: translateX(-0.2rem); }
  100% { transform: translateX(0); }
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-step-progress/dist/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,UAAU;EACV,2BAA2B;EAC3B,WAAW;EACX,8DAA8D;CAC/D,0BAA0B;EACzB,iCAAiC;EACjC,iDAAiD;AACnD;AACA;EACE,aAAa;AACf;AACA;;EAEE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EAEJ,4CAA4C;AACtD;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,YAAY;EAEJ,qCAAqC;AAC/C;AACA;EACE,yBAAyB;AAC3B;AACA;;;EAGE,gCAAgC;AAClC;AACA;EACE,YAAY;EACZ,yBAAyB;EAEjB,4CAA4C;AACtD;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kDAAkD;AACpD;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;AACnD;AACA;EACE,oBAAoB;EAEZ,oBAAoB;EAC5B,eAAe;AACjB;;AASA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,uBAAuB,EAAE;EAC/B,MAAM,qBAAqB,EAAE;EAC7B,YAAY,qBAAqB,EAAE;AACrC;AAKA;EACE,KAAK,qBAAqB,EAAE;EAC5B,YAAY,mBAAmB,EAAE;AACnC;AASA;EACE,KAAK,wBAAwB,EAAE;EAC/B,MAAM,6BAA6B,EAAE;EACrC,WAAW,8BAA8B,EAAE;EAC3C,WAAW,6BAA6B,EAAE;EAC1C,MAAM,8BAA8B,EAAE;EACtC,OAAO,wBAAwB,EAAE;AACnC","sourcesContent":["._53Ji7 {\n  padding: 2rem;\n}\n._53Ji7, ._53Ji7 * {\n  box-sizing: border-box;\n}\n._1Lo2h {\n  margin: 0 0 1rem 0;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n._2Jtxm {\n  list-style: none;\n  position: relative;\n  text-align: center;\n  flex: 1 1 auto;\n  position: relative;\n}\n\n._2Jtxm::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  height: 3px;\n  width: 100%;\n  right: 50%;\n  transform: translateY(-50%);\n  z-index: -1;\n  background: linear-gradient(to left, #e7eaf3 50%, #4db193 50%);\n\tbackground-size: 200% 100%;\n  background-position: right bottom;\n  transition: background-position 200ms ease-in-out;\n}\n._2Jtxm:first-child::before {\n  content: none;\n}\n._2Jtxm ._2kL0S,\n._2Jtxm ._2JvrO {\n  background-color: #e7eaf3;\n  color: var(--text-normal);\n  border-radius: 50%;\n  height: 2.5rem;\n  width: 2.5rem;\n  line-height: 2.5rem;\n  display: inline-flex;\n  transform-origin: center;\n  align-items: center;\n  justify-content: center;\n}\n._2kL0S, ._2JvrO {\n  transition: background-color 250ms ease;\n}\n._2Jtxm ._1hzhf {\n  color: var(--text-normal);\n  position: absolute;\n  top: 120%;\n  left: 50%;\n  transform: translateX(-50%);\n}\n._2Jtxm ._1ixJ3 {\n  display: block;\n}\n._2Jtxm._2ZUAI ._2JvrO {\n  background-color: #4db193;\n  color: white;\n  -webkit-animation: _3SDnc 400ms ease-in-out forwards;\n          animation: _3SDnc 400ms ease-in-out forwards;\n}\n._2Jtxm._2ZUAI ._2JvrO:hover {\n  background-color: #42997f;\n}\n._2Jtxm._35Ago ._2kL0S {\n  background-color: #387cf6;\n  color: white;\n  -webkit-animation: _JAh3L 400ms ease forwards;\n          animation: _JAh3L 400ms ease forwards;\n}\n._2Jtxm._35Ago ._2kL0S:hover {\n  background-color: #316ddb;\n}\n._2Jtxm._2ZUAI::before,\n._2Jtxm._35Ago::before,\n._2Jtxm._1CcaK::before {\n  background-position: left bottom;\n}\n._2Jtxm._1CcaK ._2JvrO {\n  color: white;\n  background-color: #bb392d;\n  -webkit-animation: _1ujce 350ms ease-in-out forwards;\n          animation: _1ujce 350ms ease-in-out forwards;\n}\n._2_g61 {\n  padding: 1rem;\n}\n._3uApM {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 1rem;\n}\n._2pGos {\n  padding: 0.75rem 1rem;\n  border-radius: 0.25rem;\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n}\n._3CDiP {\n  border: 1px solid #d1d9eb;\n}\n._3CDiP:hover {\n  background-color: #f3f7ff;\n  box-shadow: 0px 3px 6px 0 rgba(190, 201, 228, 0.3);\n}\n._hsN1w {\n  background-color: #397cf6;\n  border: 1px solid #397cf6;\n  color: white;\n}\n._hsN1w:hover {\n  background-color: #316ddb;\n  border: 1px solid #316ddb;\n  box-shadow: 0px 3px 6px 0 rgba(57, 124, 246, 0.3);\n}\n._2pGos._2RWmX {\n  pointer-events: none;\n  -webkit-filter: opacity(0.7);\n          filter: opacity(0.7);\n  cursor: default;\n}\n\n@-webkit-keyframes _JAh3L {\n  0% { transform: scale(1); }\n  10% { transform: scale(0.975); }\n  40% { transform: scale(1.4); }\n  50%, 100% { transform: scale(1.2); }\n}\n\n@keyframes _JAh3L {\n  0% { transform: scale(1); }\n  10% { transform: scale(0.975); }\n  40% { transform: scale(1.4); }\n  50%, 100% { transform: scale(1.2); }\n}\n@-webkit-keyframes _3SDnc {\n  0% { transform: scale(1.2); }\n  35%, 100% { transform: scale(1); }\n}\n@keyframes _3SDnc {\n  0% { transform: scale(1.2); }\n  35%, 100% { transform: scale(1); }\n}\n@-webkit-keyframes _1ujce {\n  0% { transform: translateX(0); }\n  15% { transform: translateX(0.2rem); }\n  30%, 60% { transform: translateX(-0.4rem); }\n  45%, 75% { transform: translateX(0.4rem); }\n  90% { transform: translateX(-0.2rem); }\n  100% { transform: translateX(0); }\n}\n@keyframes _1ujce {\n  0% { transform: translateX(0); }\n  15% { transform: translateX(0.2rem); }\n  30%, 60% { transform: translateX(-0.4rem); }\n  45%, 75% { transform: translateX(0.4rem); }\n  90% { transform: translateX(-0.2rem); }\n  100% { transform: translateX(0); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
